import ManagementNewsfeed from "./ManagementNewsfeed";

export default ManagementNewsfeed;